import React, { useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CopyDoneIcon from 'assets/images/copy_done.png';
import { useTranslation } from 'react-i18next';

interface CopyButtonProps {
    className?: string;
    onCopy: () => void;
}

const CopyButton: React.FC<CopyButtonProps> = ({ className = '', onCopy }) => {
    const { t } = useTranslation();
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const copiedRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const onCopyHandler = () => {
        setIsCopied(true);
        if (copiedRef.current) {
            clearTimeout(copiedRef.current);
        }
        onCopy();
        copiedRef.current = setTimeout(() => {
            setIsCopied(false);
            copiedRef.current = null;
        }, 2000);
    };

    return (
        <Tooltip placement="top" title={t('web_app.tooltips.copy_btn')} className={className}>
            <span>
                <button onClick={onCopyHandler} className="action-btn">
                    {isCopied ? (
                        <img src={CopyDoneIcon} alt="copy-done" />
                    ) : (
                        <ContentCopyOutlinedIcon />
                    )}
                </button>
            </span>
        </Tooltip>
    );
};

export default CopyButton;
